import React from "react";

import { Switch, Route, Redirect } from "react-router";
import PositionsTable from "../../features/positions-table";

const Positions = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={PositionsTable} />
      {/* The add and edit screens are gone (positions are managed by DEV, see
          api/positions.ts); send stale bookmarks back to the read-only list. */}
      <Redirect to={match.path} />
    </Switch>
  );
};

export default Positions;
